import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4","key":"svg-0"}]]

/**
 * IconCornerRightDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLXJpZ2h0LWRvd24iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNmg2YTMgMyAwIDAgMSAzIDN2MTBsLTQgLTRtOCAwbC00IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/corner-right-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerRightDown = createReactComponent('outline', 'corner-right-down', 'CornerRightDown', __iconNode);

export default IconCornerRightDown;